import { useEffect, useState } from 'react';

// Same key/event as public/configurator/js/cart.js, which the configurator writes to.
const KEY = 'orion-cart-v1';

export const readCart = () => {
  try {
    const data = JSON.parse(localStorage.getItem(KEY) || '[]');
    return Array.isArray(data) ? data : [];
  } catch {
    return [];
  }
};

export const writeCart = (items) => {
  localStorage.setItem(KEY, JSON.stringify(items));
  document.dispatchEvent(new CustomEvent('orion:cart', { detail: { items } }));
};

export const unitPrice = (i) => i.price ?? i.estimate ?? null;

export const formatPrice = (v) => (v == null ? 'по запросу' : new Intl.NumberFormat('ru-RU').format(v) + ' ₽');

export const useCart = () => {
  const [items, setItems] = useState(readCart);
  useEffect(() => {
    const sync = () => setItems(readCart());
    document.addEventListener('orion:cart', sync);
    window.addEventListener('storage', sync);
    return () => {
      document.removeEventListener('orion:cart', sync);
      window.removeEventListener('storage', sync);
    };
  }, []);
  return items;
};
